<app-loader *ngIf="(fileShareIsLoading$ | async) || fileTypeList.length === 0"></app-loader>

<div class="flex flex-col h-full">
    <div class="custom-bg-white relative px-6 h-full pb-28">
        @if (fileList$ | async; as files) {
        <div class="my-5">
            <h2 class="text-primary text-2xl">I tuoi file</h2>
            @if (files.length > 0) {
            <p class="mt-3">Esplora i tuoi file o caricane di nuovi</p>
            }
            <small class="mt-3">Numero massimo di file:&nbsp;{{ (userUploadedFileCount$ | async) ?? 0 }}/{{ maxNumFiles }}</small>
        </div>
        @if (files.length === 0) {
        <p>Non ci sono ancora file 🙁</p>
        } @else {
        <ul>
            @for (file of files; track $index) {
            <li class="border-2 border-f7f7f7 bg-light-linear rounded-lg py-4 px-3 mt-2 card-shadow cursor-pointer hover:border-primary">
                <a href="" (click)="download($event, file)" class="flex items-center w-full">
                    <div class="basis-1/12">
                        <img class="size-12 object-contain" alt="" src="../../../../../assets/img/utility/doc.png" />
                    </div>
                    <div class="basis-11/12 ms-3.5">
                        <div class="flex items-center justify-between">
                            <div>
                                <h2 class="font-bold text-base">
                                    {{ file.title }}
                                </h2>
                            </div>
                        </div>
                        <div class="bg-light-linear rounded mt-2" *ngIf="file.pathOnClient">
                            <span class="text-sm text-black truncate inline-block w-full" style="container-type: inline-size">{{ file.pathOnClient }}</span>
                        </div>
                        <div class="bg-light-linear rounded mt-2">
                            <span class="text-sm text-black truncate inline-block w-full" style="container-type: inline-size">
                                Autore: <span class="font-bold">{{ file.qualification ? file.qualification : 'Caricato da te' }}</span>
                            </span>
                        </div>
                        <div class="bg-light-linear rounded">
                            <span class="text-sm text-black truncate inline-block w-full" style="container-type: inline-size">
                                Data di caricamento: {{ file.createdDate | date:'dd/MM/YYYY HH:mm' }}
                            </span>
                        </div>
                    </div>
                </a>
            </li>
            }
        </ul>
        }


        @if (fileIsDownloading$ | async) {
        <div class="loader-container-fullscreen flex flex-col justify-center items-center pb-5">
            <span class="my-5">File download in corso...</span>
            <span class="loader"></span>
        </div>
        }

        @if (((userUploadedFileCount$ | async) ?? 0) >= maxNumFiles) {
        <p class="my-5">Hai raggiunto il <strong>numero massimo</strong> di file caricabili 😵</p>
        } @else {
        <div class="my-5">
            <div class="flex items-center justify-between my-5">
                <h2 class="text-primary text-2xl">Carica un nuovo file</h2>
            </div>
            <form [formGroup]="uploadForm" (ngSubmit)="onUploadFormSubmit()">
                <div class="flex flex-col">
                    <div class="relative mt-2.5">
                        <label for="type" class="block mb-2 text-sm font-medium text-text-color"><span class="text-danger">*</span>&nbsp;Seleziona tipologia</label>
                        <select formControlName="type" id="type" class="bg-white border border-black text-text-color text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5">
                            <option [ngValue]="null" disabled selected>-</option>
                            @for (type of fileTypeList; track $index) {
                            <option [ngValue]="type.developerName">{{ type.label }}</option>
                            }
                        </select>
                    </div>
                    <div class="relative mt-2.5">
                        <label class="block mb-2 text-sm font-medium text-gray-900" for="file_input">Upload file</label>
                        <input accept="application/pdf,image/png,image/jpeg" (change)="onFilePicked($event)" class="block w-full text-sm text-text-color border border-black rounded-lg cursor-pointer bg-white focus:outline-none" aria-describedby="file_input_help" id="file_input" type="file">
                        <p class="mt-1 text-sm text-text-color" id="file_input_help">PDF, PNG, JPG.</p>
                    </div>
                    <div class="relative mt-2.5 flex items-center justify-end w-full">
                        <button class="py-2 border-0 bg-primary rounded-lg flex items-center justify-center"
                                [ngClass]="{'px-2': !(fileIsUploading$ | async), 'px-4': (fileIsUploading$ | async) }"
                                type="submit" [disabled]="uploadForm.invalid || (fileIsUploading$ | async)">
                            <div class="flex items-center">
                                @if (fileIsUploading$ | async) {
                                <span class="button-loader"></span>
                                } @else {
                                <span class="text-white text-sm font-bold">Carica file</span>
                                }
                            </div>
                        </button>
                    </div>
                </div>
            </form>
        </div>
        }
        }
    </div>
</div>
